import { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Image, Typography, Row, Col } from 'antd';
import generateKey from 'utils/generateKey';
import { useInterval } from 'hooks/useInterval';
// import mobileIcon from 'assets/images/mobile-icon.svg';
import mobileIcon from 'assets/images/neutral-1.svg';
import emailIcon from 'assets/images/Group 3.svg';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { Attachments } from 'types';
import { EnquirySuccessPage } from '../paymentSuccessPage';
import { Spinner } from 'components';
import type { InputRef } from 'antd';
// import { ActionType, RegistrationFlowContext } from 'contexts/registration';
import {
  Card,
  // Container,
  InvalidTextMsg,
  // OtpInputField,
  ResendCaptchaSection,
  SubTitle,
  // OtpInputContainer,
  // OtpInputWrapper,
  NewInput,

  // OtpInput,
} from './styledComponents';
import { getConfig } from 'configs';
// import { SessionStorageKey, sessionStorageService } from '../../../../utils/SessionStorageService';
// import { useRegistrationStateQuery } from '../../../../hooks/useRegistrationStateQuery';
import GoogleCaptcha from '../../../../components/googleCaptcha';
// import { getBirthdayString } from 'utils/registration';
// import { useKeycloakReady } from 'hooks';
import {
  ApiFetcherError,
  useRequestOtp,
  useValidateOtp,
  useEmailOtp,
  useEmailOtpValidate,
  useRequestSubmission,
  useLifeUserProfile,
  // useUserRegister,
  // useLifeUserRegister,
  // useRegister,
  // usePatchExistingUser,
} from 'all-in-one-shared-api';
// import {setErrorCodeFun} from 'utils/setErrorCodeFun/setErrorCodeFun';

const { Title, Text, Link } = Typography;

const RESEND_COUNTDOWN_PERIOD = 60;

const config = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'mock');

type fieldChangestype = {
  key: string;
  changedValue: string[];
  originalValue: string[];
};

type requestData2type = {
  fieldChanges: fieldChangestype[] | [];
  changeType: string | '';
  uploadFlag: boolean;
  companyCode: string | '';
  policyNo: string | '';
  correspondencePolicyNo: string | '';
};

interface LocationState {
  countryCode: string;
  loginId?: string;
  mobile?: string;
  email?: string;
  requestData2: requestData2type;
  documents: Attachments;
  policyNumber: string;
}
export const LifechgepaymentOtpVerificationPage = (): JSX.Element => {
  // const [resendCountdown, setResendCountdown] = useState(RESEND_COUNTDOWN_PERIOD);
  const [otpArray, setOtpArray] = useState('');
  const [isAllowEdit, setIsAllowEdit] = useState(false);
  const { token, tokenParsed } = useKeycloakReady();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [isDone, setIsDone] = useState(false);
  // const registrationState = useRegistrationStateQuery();
  // const [otpInput, setOtpInput] = useState("");
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [countdown, setCountdown] = useState(RESEND_COUNTDOWN_PERIOD);
  const [requestOtpCount, setRequestOtpCount] = useState(0);
  const [mobile, setmobile] = useState<string>();
  const [email, setemail] = useState<string>();
  const [countryCode, setcountryCode] = useState<string>();
  const [areaCode, setAreaCode] = useState<string>();
  const [isShowCaptcha, setIsShowCaptcha] = useState(false);
  const [startLoading, setloding] = useState(false);
  // const [disabledVerification, setDisabledVerification] = useState(false);
  // const { dispatch } = useContext(RegistrationFlowContext);
  const location = useLocation();
  const [enquiryReference, setEnquiryReference] = useState('');
  const { requestData2, policyNumber } = (location.state as LocationState) ?? {};
  const { shouldFetch: profileshouldFetch, data: profileInfoData } = useLifeUserProfile(
    'useLifeUserProfile',
    token || '',
  );
  useEffect(() => {
    profileshouldFetch(true);
    if (profileInfoData) {
      setmobile(profileInfoData.mobile);
      setemail(profileInfoData.email);
      setcountryCode(profileInfoData.countryCode);
      setAreaCode(profileInfoData.areaCode);
    }
  }, [profileshouldFetch, profileInfoData]);
  const loginId = tokenParsed?.preferred_username;
  // Note(Anson Kan): assuming `mobile` exists for the current user
  const mobileNumber = (countryCode ?? '') + (areaCode ?? '') + (mobile ?? '');
  const [key, setKey] = useState<string>('678687678687');
  const [showTips, setShowTips] = useState(false);
  const [validateKey, setValidateKey] = useState<string>('');
  const { shouldFetch /*, isLoading */ } = useRequestOtp(key, loginId ?? '', mobileNumber, {
    shouldRetryOnError: false,
    onSuccess: () => {
      shouldFetch(false);
    },
    onError: (error) => {
      if (error) {
        shouldFetch(false);
        const apiError = error as ApiFetcherError;
        setErrorMsg(apiError.code ? apiError.code : error.message);
      }
    },
  });
  const { shouldFetch: shouldEmailFetch /*, isLoading */ } = useEmailOtp(key, loginId ?? '', email ?? '', {
    shouldRetryOnError: false,
    onSuccess: () => {
      shouldEmailFetch(false);
    },
    onError: (error) => {
      if (error) {
        shouldEmailFetch(false);
        const apiError = error as ApiFetcherError;
        setErrorMsg(apiError.code ? apiError.code : error.message);
      }
    },
  });
  const {
    data: requestData,
    error: requestError,
    shouldFetch: shouldRequestFetch,
  } = useRequestSubmission(key, token || '', {
    ...requestData2,
  });
  useEffect(() => {
    if (requestData && requestData.bpmReferenceNo) {
      setEnquiryReference(requestData.bpmReferenceNo);
      setTimeout(() => {
        setIsDone(true);
      }, 500);
      setloding(false);
      shouldRequestFetch(false);
    }
  }, [requestData, shouldRequestFetch, setIsDone, setEnquiryReference]);
  useEffect(() => {
    if (requestError) {
      shouldRequestFetch(false);
      setloding(false);
      navigate('/ChangeRequestError', {
        replace: true,
      });
    }
  }, [requestError, shouldRequestFetch, i18n, navigate]);
  const { shouldFetch: shouldEmailValidate /*, isLoading: isValidating */ } = useEmailOtpValidate(
    validateKey,
    loginId ?? '',
    otpArray,
    {
      shouldRetryOnError: false,
      onSuccess: (validateResponse) => {
        shouldEmailValidate(false);
        if (validateResponse) {
          if (validateResponse.success) {
            setErrorMsg(null);
            setloding(true);
            shouldRequestFetch(true);
            console.log('2222');
          } else {
            //光標移入第一個輸入框
            if (digit1InputRef.current) {
              digit1InputRef.current.focus();
            } else {
              console.error('digit1InputRef.current is null');
            }
            setOtpArray('');
            setErrorMsg(validateResponse.message);
          }
        }
      },
    },
  );

  const { shouldFetch: shouldValidateOtp } = useValidateOtp(validateKey, loginId ?? '', otpArray, {
    shouldRetryOnError: false,
    onSuccess: (validateResponse) => {
      shouldValidateOtp(false);
      if (validateResponse) {
        if (validateResponse.success) {
          setErrorMsg(null);
          setloding(true);
          console.log('reuestdata878787878787', requestData2);
          shouldRequestFetch(true);
          console.log('33333333');
          // shouldLifeRegister(true);
        } else {
          //光標移入第一個輸入框
          if (digit1InputRef.current) {
            digit1InputRef.current.focus();
          } else {
            console.error('digit1InputRef.current is null');
          }
          setOtpArray('');
          setErrorMsg(validateResponse.message);
        }
      }
    },
  });

  useInterval(
    () => {
      setCountdown(countdown - 1);
    },
    countdown >= 0 ? 1000 : null,
  );
  const digit1InputRef = useRef<InputRef>(null);

  // const resendCountdownIntervalID: NodeJS.Timeout | null = null;

  // const startResendCountdown = useCallback(() => {
  //   // 如果计时器已经存在，清除它
  //   if (resendCountdownIntervalID) {
  //     clearInterval(resendCountdownIntervalID);
  //   }

  //   // 设置新的计时器
  //   resendCountdownIntervalID = setInterval(() => {
  //     if (resendCountdown <= 0) {
  //       clearInterval(resendCountdownIntervalID as NodeJS.Timeout); // 强制断言类型为 NodeJS.Timeout
  //     } else {
  //       setResendCountdown(resendCountdown - 1);
  //     }
  //   }, 1000);
  // }, [resendCountdownIntervalID]);
  const handleResendOtp = () => {
    if (!showTips) setShowTips(true);

    if (requestOtpCount < 3) {
      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }

    // setOtpInput("");
    setRequestOtpCount(requestOtpCount + 1);
    console.log('onPressResend()->');
    setKey(generateKey());

    setOtpArray('');
    setErrorMsg('life.register.resendOtp');
    if (digit1InputRef.current) {
      digit1InputRef.current.focus();
    }

    // setResendCountdown(RESEND_COUNTDOWN_PERIOD);
    // startResendCountdown();
    if (email) {
      shouldEmailFetch(true);
    } else if (mobile) {
      shouldFetch(true);
    }
  };

  // useEffect(() => {
  //   startResendCountdown();

  //   return () => {
  //     if (resendCountdownIntervalID) {
  //       clearInterval(resendCountdownIntervalID);
  //     }
  //   };
  // }, [resendCountdownIntervalID, startResendCountdown]);
  useEffect(() => {
    if (requestOtpCount >= 3) {
      setIsShowCaptcha(true);
    }
  }, [requestOtpCount, setIsShowCaptcha]);
  useEffect(() => {
    // console.log('location', location);
    // console.log('location', email);
    // console.log('location', mobile);
    setKey(generateKey());
    // 如果email存在，那麼shouldEmailFetch(true),否則shouldFetch(true)
    if (email) {
      shouldEmailFetch(true);
    } else if (mobile) {
      shouldFetch(true);
    }
  }, [email, mobile, shouldFetch, shouldEmailFetch, location]);
  // useEffect(() => {
  //   if (!otpArray && errorMsg) {
  //     setErrorMsg('');
  //   }
  //   if (!otpArray || !/\d{6}/.test(otpArray)) {
  //     setDisabledVerification(true);
  //   } else {
  //     setDisabledVerification(false);
  //   }
  // }, [errorMsg, otpArray]);
  const handleVerifyOtp = useCallback(() => {
    if (!/\d{6}/.test(otpArray)) {
      setErrorMsg(t('smsOtpVerification.code-not-found'));
      return;
    }

    setValidateKey(generateKey());
    if (email) {
      shouldEmailValidate(true);
    } else if (mobile) {
      shouldValidateOtp(true);
    }

    // mutateVerifyOtp();
  }, [otpArray, email, mobile, setErrorMsg, setValidateKey, shouldEmailValidate, shouldValidateOtp, t]);
  useEffect(() => {
    if (otpArray.length === 6) {
      handleVerifyOtp();
    }
  }, [otpArray, handleVerifyOtp]);
  useEffect(() => {
    if (errorMsg && errorMsg == 'smsOtpVerification.retry-limit-exceeded') {
      setIsAllowEdit(true);

      // setCountdown(30);
      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }
  }, [errorMsg]);
  useEffect(() => {
    if (countdown === 0) {
      setIsAllowEdit(false);
    }
  }, [countdown]);

  const onCaptchaSuccess = () => {
    setIsShowCaptcha(false);
  };

  const onCaptchaError = () => {
    setErrorMsg(t('login.error.captchaDigitError'));
  };

  const onOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNaN(Number(e.target.value))) {
      return;
    }
    setOtpArray(e.target.value);
    setErrorMsg(null);
    // return (event: React.ChangeEvent<HTMLInputElement>) => {
    //   const value = event.target.value;

    //   // 确保输入的是数字
    //   if (isNaN(Number(value))) {
    //     return;
    //   }

    //   const otpArrayCopy = [...otpArray]; // 创建otpArray的副本
    //   otpArrayCopy[index] = value;
    //   setOtpArray(otpArrayCopy);

    //   // 如果输入不为空，自动聚焦到下一个输入框
    //   if (value !== '') {
    //     const nextInputIndex = index + 1;
    //     if (nextInputIndex < otpArray.length) {
    //       (document.querySelectorAll('.single-digit-input')[nextInputIndex] as HTMLInputElement)?.focus();
    //     }
    //   }

    //   setErrorMsg(null);
    // };
  };
  function maskEmail(email: string) {
    if (!email) return '';
    // ???????????????
    const [username, domain] = email.split('@');
    // const [domains, coms,countrys] = domain.split('.');
    const domainList = domain.split('.');

    // ???????,???1???1?,???*??
    const maskedUsername = username.charAt(0) + '*'.repeat(username.length - 2) + username.slice(-1);
    const maskedDomain = domainList[0].charAt(0) + '*'.repeat(domainList[0].length - 2) + domainList[0].slice(-1);
    if (domainList.length > 2) {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1] + '.' + domainList[2];
    } else {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1];
    }
    // ??????????
  }
  function maskPhoneNumber(phoneNumber: string) {
    if (!phoneNumber) return '';
    // ???3???4?,???*??
    const visibleDigits = 2; // ????,??????????
    const startDigits = phoneNumber.substring(0, visibleDigits);
    const endDigits = phoneNumber.substring(phoneNumber.length - 2);

    // ?????*?????
    const maskedPart = '*'.repeat(phoneNumber.length - visibleDigits - 2);

    // ??????????
    return startDigits + maskedPart + endDigits;
  }
  if (isDone) {
    return <EnquirySuccessPage enquiryReference={enquiryReference} policyNo={policyNumber} />;
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        paddingLeft: '40px',
        paddingRight: '40px',
      }}
    >
      {/* <img src={forgotIcon} alt="forgot-icon" style={{ marginBottom: 12 }} /> */}
      <Typography.Title
        level={3}
        style={{ fontSize: '33px', fontFamily: 'Roboto400', color: '#20252b', fontWeight: '400' }}
      >
        {t('life.MakeRequest.payment.ChangeRequest')}
      </Typography.Title>
      <div
        className="register_otp_wrapper"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
        }}
      >
        <Card style={{ border: 0, width: '100%', maxWidth: '400px' }}>
          <Row justify="center" gutter={[16, { xs: 8, sm: 16, md: 24 }]}>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              {/* <Space align="center" direction="vertical"> */}
              <Title level={3}>{t('smsOtpVerification.screenTitle')}</Title>
            </Col>
            {!email && showTips && (
              <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
                <Title level={3} style={{ fontSize: '20px', color: 'red' }}>
                  {t('sms.othersOtpLife')}
                </Title>
              </Col>
            )}
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <Image
                height="10.25rem"
                src={email ? emailIcon : mobileIcon}
                preview={false}
                style={{ height: '153px' }}
              />
              {/* </Space> */}
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <SubTitle
                style={{
                  display: 'inline-block',
                  textAlign: 'center',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  color: '#6f7072',
                }}
              >
                {email ? t('smsOtpVerification.emailScreenSubtitle') : t('smsOtpVerification.mobileScreenSubtitle')}
                <br />
                {email
                  ? maskEmail(email)
                  : mobile
                  ? countryCode + '  ' + (areaCode ? `${areaCode} ` : '') + maskPhoneNumber(mobile)
                  : null}
              </SubTitle>
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              {/* <OtpInputContainer>
                {[digit1InputRef, digit2InputRef, digit3InputRef, digit4InputRef, digit5InputRef, digit6InputRef].map(
                  (textInputRef, index) => (
                    <OtpInputWrapper key={index}>
                      <input
                        style={{
                          width: '40px',
                          height: '40px',
                          textAlign: 'center',
                          fontSize: '20px',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                        }}
                        type="text"
                        maxLength={1}
                        value={otpArray[index]}
                        onKeyPress={onOtpKeyPress(index)}
                        onChange={onOtpChange(index)}
                        className="single-digit-input"
                        autoFocus={index === 0}
                        ref={textInputRef}
                        disabled={isAllowEdit}
                      />
                    </OtpInputWrapper>
                  ),
                )}
              </OtpInputContainer> */}
              <NewInput
                maxLength={6}
                value={otpArray}
                onChange={onOtpChange}
                className="single-digit-input"
                autoFocus
                ref={digit1InputRef}
                disabled={isAllowEdit}
              />
            </Col>
            <Col xs={24} md={24} style={{ textAlign: 'center' }}>
              {errorMsg && <InvalidTextMsg type="danger">{t(errorMsg)}</InvalidTextMsg>}
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <ResendCaptchaSection style={{ fontSize: '20px', width: '340px' }}>
                {isShowCaptcha ? (
                  <GoogleCaptcha
                    hl={i18n.language}
                    sitekey={config.captchaSiteKey}
                    onChange={onCaptchaSuccess}
                    onError={onCaptchaError}
                    onExpired={onCaptchaError}
                  />
                ) : (
                  <>
                    <Link
                      onClick={countdown > 0 ? (e) => e.preventDefault() : handleResendOtp}
                      style={{
                        fontFamily: 'Roboto400',
                        fontSize: '17px',
                        pointerEvents: countdown > 0 ? 'none' : 'auto',
                        color: countdown > 0 ? 'gray' : '#752127', // 设置禁用时颜色为灰色
                      }}
                    >
                      {t('smsOtpVerification.resend')}
                    </Link>
                    {countdown >= 0 && (
                      <Text type="secondary" style={{ fontFamily: 'Roboto400', fontSize: '17px' }}>
                        {t('smsOtpVerification.resendCountdownText', {
                          second: countdown,
                        })}
                      </Text>
                    )}
                  </>
                )}
              </ResendCaptchaSection>
              {startLoading && <Spinner />}
            </Col>

            {/* <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: '100%' }}>
                <Button
                  block
                  type="primary"
                  disabled={disabledVerification}
                  size="large"
                  onClick={handleVerifyOtp}
                  style={{ height: '50px' }}
                >
                  {t('common.submit')}
                </Button>
              </div>
            </Col> */}
            <Link
              onClick={() => {
                navigate('/MakeRequestPage');
              }}
              style={{
                fontWeight: 'normal',
                marginLeft: 4,
                marginRight: 4,
                color: '#C21B17',
                textDecoration: 'underline',
                fontFamily: 'Roboto400',
                fontSize: '17px',
              }}
            >
              {t('life.enquiry.Cancel')}
            </Link>
          </Row>
        </Card>
      </div>
    </div>
  );
};
